import { lazy, Suspense } from 'react';
const BranchMapView = lazy(() => import('../BranchMapView'));

function Index() {
	return (
		<div className="container">
			<Suspense fallback={<div>Loading...</div>}>{<BranchMapView tabKey="map-view" />}</Suspense>
		</div>
	);
}

export default Index;
